/**
 * factFindAccess.service.ts — Layer 3: Shared Fact-Find Link Access Domain
 *
 * OTP-based identity verification for external recipients opening a shared
 * fact-find link (unauthenticated flow — see VerifyAccessPage).
 */

import { getRequest, postRequest } from './http.service';
import {
  URL_FACTFIND_ACCESS_RECIPIENTS,
  URL_FACTFIND_ACCESS_SEND_OTP,
  URL_FACTFIND_ACCESS_VERIFY_OTP,
} from './url.service';

/** Get the list of authorized recipient emails for a shared fact-find link */
export const fetchFactFindAccessRecipients = (accessId: string) =>
  getRequest(URL_FACTFIND_ACCESS_RECIPIENTS(accessId));

/** Send a one-time verification code to the selected recipient email */
export const sendFactFindAccessOtp = (accessId: string, recipientEmail: string) =>
  postRequest(URL_FACTFIND_ACCESS_SEND_OTP, { accessId, recipientEmail });

/** Verify the OTP and receive the clientId to render the fact-find */
export const verifyFactFindAccessOtp = (accessId: string, otp: string, recipientEmail: string) =>
  postRequest(URL_FACTFIND_ACCESS_VERIFY_OTP, { accessId, otp, recipientEmail });
